import './index.css'
import "./styles/typography.scss"
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

const STRICT_MODE = false

const Strict = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

const NoStrict = <App />

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(STRICT_MODE ? Strict : NoStrict)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
